import type { AsterionApp } from '@/types';

export const ASTERION_APPS: AsterionApp[] = [
  {
    id:          'report',
    name:        'Asterion Report',
    description: 'Rapports d\'inspection pour ateliers d\'usinage — 95 % des cotes extraites automatiquement du plan (OCR + IA, valeurs manuscrites comprises), dessin bullé, GD&T ASME Y14.5, détection des non-conformités. 45 min → 7 min par rapport.',
    icon:        'FileText',
    logo:        'icon-asterion-report',
    logoFull:    'logo-asterion-report',
    colorVar:    'var(--color-anticiper)',
    colorRgbVar: 'var(--color-anticiper-rgb)',
    tag:         'IA · OCR · GD&T',
    screenshot:  '/asterion/shot-report.gif',
  },
  {
    id:          'qms',
    name:        'Asterion QMS',
    description: 'Système qualité ISO 9001:2015 pour PME manufacturières — NC/CAPA, risques cotés P×G×D, audits, revue de direction, compétences et fournisseurs. Jamais bloquant : un écart se déclare en 30 secondes depuis le téléphone, l\'information circule ensuite sans resaisie.',
    icon:        'FileCheck',
    logo:        'icon-asterion-qms',
    logoFull:    'logo-asterion-qms',
    colorVar:    'var(--color-ameliorer)',
    colorRgbVar: 'var(--color-ameliorer-rgb)',
    tag:         'ISO 9001 · NC/CAPA',
    screenshot:  '/asterion/shot-qms.jpg',
  },
  {
    id:          'gage',
    name:        'Asterion Gage',
    description: 'Le parc d\'instruments de mesure sous contrôle — registre complet, étalonnages lissés sur l\'année, alertes avant échéance, certificats de laboratoire rattachés automatiquement, étiquettes P-touch à codes couleur. Aligné ISO 17025, exports prêts pour l\'audit.',
    icon:        'Ruler',
    logo:        'icon-asterion-gage',
    logoFull:    'logo-asterion-gage',
    colorVar:    'var(--color-gage)',
    colorRgbVar: 'var(--color-gage-rgb)',
    tag:         'ISO 17025 · Métrologie',
    screenshot:  '/asterion/shot-gage.jpg',
  },
  {
    id:          'outflow',
    name:        'Asterion Outflow',
    description: 'Gestion des expéditions et logistique sortante — bons d\'expédition, packing lists, déclarations douanières USMCA générées par IA, suivi de livraison.',
    icon:        'Truck',
    colorVar:    'var(--color-reagir)',
    colorRgbVar: 'var(--color-reagir-rgb)',
    tag:         'Expéditions · USMCA · IA',
    isDraft:     true,
  },
  {
    id:          'kairos',
    name:        'Asterion Kairos',
    description: 'Planification et ordonnancement industriel — Gantt, scheduling, suivi des jalons et coordination des étapes de fabrication adaptés au contexte atelier.',
    icon:        'GanttChart',
    logo:        'icon-asterion-kairos',
    logoFull:    'logo-asterion-kairos',
    screenshot:  '/asterion/shot-kairos.jpg',
    colorVar:    'var(--color-kairos)',
    colorRgbVar: 'var(--color-kairos-rgb)',
    tag:         'Gantt · Scheduling',
  },
  {
    id:          'praxis',
    name:        'Asterion Praxis',
    description: 'Dossiers qualité livrables pour la sous-traitance — chaque requis contractuel devient une ligne traçable, l\'IA vérifie CoC, mill tests et rapports NDT sous validation humaine, puis assemble le dossier PDF ordonné, prêt à envoyer. Fini les paiements retenus pour un certificat manquant.',
    icon:        'BookOpen',
    logo:        'icon-asterion-praxis',
    logoFull:    'logo-asterion-praxis',
    colorVar:    'var(--color-praxis)',
    colorRgbVar: 'var(--color-praxis-rgb)',
    tag:         'IA · Dossiers Qualité',
    isDraft:     true,
  },
  {
    id:          'kraken',
    name:        'Asterion Kraken',
    description: 'Gestion des arrêts annuels de grande envergure — carte interactive du site, connectivité terrain, rapports par SMS, flux de communication des équipes, Gantt et Kanban.',
    icon:        'Anchor',
    colorVar:    'var(--color-ciel)',
    colorRgbVar: 'var(--color-ciel-rgb)',
    tag:         'Arrêts majeurs · Gantt · Kanban',
    isDraft:     true,
  },
];
